"use client"

import { useEffect, useRef } from "react"
import type { StateCaptcha } from "@/modules/captcha/hooks/use-captcha"

interface OpsiRenderTurnstile {
  sitekey: string
  theme?: "auto" | "light" | "dark"
  appearance?: "always" | "execute" | "interaction-only"
  callback: (token: string) => void
  "expired-callback": () => void
  "error-callback": () => void
}

declare global {
  interface Window {
    turnstile?: {
      render: (elemen: HTMLElement, opsi: OpsiRenderTurnstile) => string
      remove: (id: string) => void
    }
  }
}

const URL_SKRIP = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"

let janjiSkrip: Promise<void> | null = null

function muatSkripTurnstile(): Promise<void> {
  if (window.turnstile) return Promise.resolve()
  if (janjiSkrip) return janjiSkrip

  janjiSkrip = new Promise((selesai, gagal) => {
    const skrip = document.createElement("script")
    skrip.src = URL_SKRIP
    skrip.async = true
    skrip.onload = () => selesai()
    skrip.onerror = () => {
      janjiSkrip = null
      gagal(new Error("Skrip captcha gagal dimuat"))
    }
    document.head.appendChild(skrip)
  })

  return janjiSkrip
}

export function CaptchaField({ captcha }: { captcha: StateCaptcha }) {
  const wadah = useRef<HTMLDivElement>(null)
  const { aktif, siteKey, versi, setToken } = captcha

  useEffect(() => {
    if (!aktif || !siteKey || !wadah.current) return

    let idWidget: string | null = null
    let dibatalkan = false
    const elemen = wadah.current

    muatSkripTurnstile()
      .then(() => {
        if (dibatalkan || !window.turnstile) return
        idWidget = window.turnstile.render(elemen, {
          sitekey: siteKey,
          theme: "auto",
          appearance: "interaction-only",
          callback: (token) => setToken(token),
          "expired-callback": () => setToken(null),
          "error-callback": () => setToken(null),
        })
      })
      .catch(() => setToken(null))

    return () => {
      dibatalkan = true
      if (idWidget && window.turnstile) window.turnstile.remove(idWidget)
    }
  }, [aktif, siteKey, versi, setToken])

  if (!aktif) return null

  return <div ref={wadah} className="flex justify-center" />
}
